import { Injectable } from '@angular/core';
import { HttpClient, HttpHandler, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LanguageService } from '../language/language.service';

@Injectable({
  providedIn: 'root'
})
export class HttpClientService extends HttpClient {
  private _apiUrl;

  constructor(
    private readonly httpHandler: HttpHandler,
    private readonly languageService: LanguageService
  ) {
    super(httpHandler);
  }

  set apiUrl(url: string) {
    if (!url || !url.length) {
      throw Error(`empty url provided`);
    }

    this._apiUrl = url;
  }

  public static objectToQueryParams(paramsObject: { [key: string]: any }): HttpParams {
    let httpParams = new HttpParams();
    Object.keys(paramsObject).forEach((key) => {
      if (paramsObject[key] !== null && paramsObject[key] !== undefined) {
        httpParams = httpParams.set(key, paramsObject[key]);
      }
    });
    return httpParams;
  }

  public mot_get<T = any>(
    url: string,
    queryParams?: HttpParams
  ): Observable<T> {
    return super.get<T>(`${this._apiUrl}${this.languageService.getSelectedLanguage().symbol}/${url}`, { params: queryParams });
  }

  public mot_post<T = any>(url: string, body?: any): Observable<T> {
    return super.post<T>(`${this._apiUrl}${this.languageService.getSelectedLanguage().symbol}/${url}`, body);
  }

  override get = () => {
    throw new Error('The get method is not accessible. Use mot_get instead.');
  };

  override post = () => {
    throw new Error('The get method is not accessible. Use mot_post instead.');
  };
}
